import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { LoginRequestBody, LoginResponse } from "./types";

export class LoginAPI extends BaseAPI<LoginRequestBody, LoginResponse> {
  protected route = ApiRoutes.auth.login;
  protected method = RequestMethod.POST;
}
